import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {environment} from '../../../../../environments/environment';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {language} from '../../../../language/vn';
import {VanBanDenService} from '../../../../service/vanbanden/service-vanbanden';
import {VanBanDen} from '../../../../models/vanbanden/vanbanden';
import {EditVanBanDenComponent} from '../soanvanban/edit.component';
import {CommandUtil} from '../../../../global/commandutil';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {FormatService} from '../../../../service/format/service-format';
import {DatePipe} from '@angular/common';
import {GXLVanBanDenComponent} from '../giaoxuly/giaoxuly.component';
import {NavItemService} from '../../../../service/staff/service-navitem';
import {LoaiVanBan} from '../../../../models/danhmuc/loaivanban';
import {LoaiVanBanService} from '../../../../service/danhmuc/service-loaivanban';

@Component({
  templateUrl: './giaoviecnhanh.component.html',

})
export class GiaoViecNhanhComponent implements OnInit, AfterViewInit {
  @ViewChild('largeModal')
  public largeModal: ModalDirective;
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public dataList: VanBanDen[];
  public submitValidate = false;
  public totalDaPhoCap: number =0;
  public totalChuaPhoCap: number =0;
  public totalItemsReal: number= 0;

  public srTuKhoa: string = '';
  public srStatus: string ='';
  public status: number[] = [
    CommandUtil.defaultValue
  ];
  public phoCap: number = -1;
  public nguoiNhapId: number = Sessioncommand.staffId;
  public nguoiChuTri: number =0;
  public maNoiGui: number =-1;
  public srFromDate: Date ;
  public srToDate: Date;
  public strF: string= '';
  public strT: string= '';
  public permission0030: boolean = false;
  public permission0032: boolean = false;
  public dataLoaiVanBan: LoaiVanBan[] = [];
  public srLoaiVanBan: number =-1;
  public srLinhVucVanBan: number =-1;
  constructor(
    public vanBanDenService: VanBanDenService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public formatService: FormatService,
    public datePipe: DatePipe,
    public navItemService: NavItemService,
    public loaiVanBanService: LoaiVanBanService

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0030', true).subscribe(
      x => {
        this.permission0030 = x >0? true: false;
      }
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0032', true).subscribe(
      x => {
        this.permission0032 = x >0? true: false;
      }
    );
    this.srStatus = this.status.join();
    this.loadTotal();
    this.search();
    this.loaiVanBanService.getAll().subscribe(data => this.dataLoaiVanBan = data);
  }
  public giaoXuLy(id: number) {
    if(this.permission0032) {
      const modalEdit = this.bsModalService.show(GXLVanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<GXLVanBanDenComponent>modalEdit.content).edit(
        id
      );
      (<GXLVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {

      });
    }

  }
  public showConfirmationModal(id: number): void {
    if(this.permission0030) {
      const modal = this.bsModalService.show(ConfirmDialogComponent);
      (<ConfirmDialogComponent>modal.content).showConfirmationModal(
        language.message,
        language.confirm_delete_question,
        language.yes,
        language.no
      );
      (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
        if (result === true) {
          this.deleteItem(id);
        }
      });
    }
  }
  get f() { return this.frmGroup.controls; }
  edit(id: number) {
    if(this.permission0030) {
      const modalEdit = this.bsModalService.show(EditVanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<EditVanBanDenComponent>modalEdit.content).edit(
        id
      );
      (<EditVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
        if (result === true) {
          this.search();
        }
      });
    }
  }
  public loadTotal()
  {
    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    this.vanBanDenService.getCountByKeyword(this.srTuKhoa, this.srLoaiVanBan, this.srLinhVucVanBan, this.srStatus, CommandUtil.daPhoCap, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, this.strF, this.strT).subscribe(recordCount => this.totalDaPhoCap = recordCount);
    this.vanBanDenService.getCountByKeyword(this.srTuKhoa, this.srLoaiVanBan, this.srLinhVucVanBan, this.srStatus, CommandUtil.chuaPhoCap, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, this.strF, this.strT).subscribe(recordCount => this.totalChuaPhoCap = recordCount);
    this.vanBanDenService.getCountByKeyword(this.srTuKhoa, this.srLoaiVanBan, this.srLinhVucVanBan, this.srStatus, CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, this.maNoiGui, this.strF, this.strT).subscribe(recordCount => this.totalItemsReal = recordCount);
  }
  search()
  {

    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    this.vanBanDenService.findAllByPaging(this.srTuKhoa,
      this.srLoaiVanBan, this.srLinhVucVanBan,
      this.srStatus,
      this.phoCap,
      this.nguoiNhapId,
      this.nguoiChuTri,
      this.maNoiGui, this.strF, this.strT,
      this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.vanBanDenService.getCountByKeyword(this.srTuKhoa,
      this.srLoaiVanBan, this.srLinhVucVanBan,
      this.srStatus,
      this.phoCap,
      this.nguoiNhapId,
      this.nguoiChuTri,
      this.maNoiGui,
      this.strF,
      this.strT).subscribe(recordCount => this.totalItems = recordCount);
  }


  deleteItem(id: number)
  {
    this.vanBanDenService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();


      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}
